<template>
  <div>
    <!-- Payment stopped -->
    <div v-if="areRemindersStopped">
      <h5>Betalingsoppfølging er stoppet!</h5>
      <p class="mt-4">Du har valgt å stoppe betalingsoppfølging av denne fakturaen.</p>

      <p>
        Vær oppmerksom på at manglende betalingsoppfølging kan ha innvirkning på eventuelle krav mot utleieforsikring og
        muligheter for juridisk forfølgelse av ubetalte husleie.
      </p>

      <div class="mt-5">
        <button class="btn btn-warning mr-2" @click="restartPayment">Gjenoppta betalingsoppfølging</button>
        <button class="btn btn-outline-secondary ml-2" @click="goBackOnParent">Lukk</button>
      </div>
    </div>
    <!-- / Payment stopped -->

    <!-- Payment restarted -->
    <div v-else-if="paymentRestarted">
      <h5>Betalingsoppfølging er gjenopptatt!</h5>
      <p class="mt-4">Du har valgt å gjenoppta betalingsoppfølging av denne fakturaen fra dette tidspunkt.</p>

      <div class="mt-5">
        <button class="btn btn-secondary ml-2" @click="goBackOnParent">Tilbake</button>
      </div>
    </div>
    <!-- / Payment restarted -->

    <!-- Payment not stopped -->
    <div v-else>
      <h5>Stopp betalingsoppfølging</h5>
      <p class="mt-4">
        Klikk “stopp betalingsoppfølging” for at det ikke lenger skal sendes betalingspåminnelser (purringer),
        inkassoprosess og/eller varsel om fravikelse relatert til denne spesifikke fakturaen.
      </p>

      <p>
        Vær obs på at manglende betalingsoppfølging kan bl.a. ha innvirkning på eventuelle krav mot utleieforsikring og
        muligheter for juridisk forfølgelse av ubetalt husleie.
      </p>

      <div class="mt-4">
        <button class="btn btn-sm btn-danger" @click="stopPayment">Stopp betalingsoppfølging</button>
        <button class="btn btn-sm btn-secondary ml-2" @click="goBackOnParent">Tilbake</button>
      </div>
    </div>
    <!-- / Payment not stopped -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    landlordId: [String, Number],
    tenancyId: [String, Number],
    orderId: [String, Number],
    remindersStopped: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      amount: '',
      paid: '',
      areRemindersStopped: false,
      paymentRestarted: false,
    };
  },

  methods: {
    ...mapActions('tenancy', ['postTenancyToggleReminder']),

    async stopPayment() {
      try {
        await this.postTenancyToggleReminder({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
          orderId: this.orderId,
          data: {
            stopAllReminders: true,
          },
        });
        this.$toast('Saved', 'success');
        this.areRemindersStopped = true;
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke lagre.', 'error');
      }
    },

    async restartPayment() {
      try {
        await this.postTenancyToggleReminder({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
          orderId: this.orderId,
          data: {
            stopAllReminders: false,
          },
        });
        this.$toast('Saved', 'success');
        this.areRemindersStopped = false;
        this.paymentRestarted = true;
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke lagre.', 'error');
      }
    },

    goBackOnParent() {
      this.$emit('back');
    },
  },

  mounted() {
    this.areRemindersStopped = JSON.parse(JSON.stringify(this.remindersStopped));
  },
};
</script>
